import { TemplateType } from '../../../../store/types/template';

const BANNER_DIMENSIONS_BY_TYPE: Partial<
  Record<TemplateType, { width: number; height: number }>
> = {
  eventTicket: {
    width: 1125,
    height: 294,
  },
  loyalty: {
    width: 1125,
    height: 432,
  },
  stampCard: {
    width: 1125,
    height: 432,
  },
};

export const getImageDimensions = (
  templateType?: TemplateType,
  options?: { expressivePassEnabled?: boolean }
) => {
  const bannerDimensions =
    templateType && templateType in BANNER_DIMENSIONS_BY_TYPE
      ? BANNER_DIMENSIONS_BY_TYPE[templateType]
      : BANNER_DIMENSIONS_BY_TYPE.loyalty;

  const googleBannerDimensions =
    options?.expressivePassEnabled && templateType !== 'transit'
      ? { width: 1032, height: 812 }
      : { width: 1032, height: 336 };

  return {
    shared: {
      logo: {
        width: 480,
        height: 150,
      },
      icon: {
        width: 660,
        height: 660,
      },
      banner: bannerDimensions,
      stampZeroImage: {
        width: 1125,
        height: 432,
      },
      stampOneImage: {
        width: 1125,
        height: 432,
      },
      stampTwoImage: {
        width: 1125,
        height: 432,
      },
      stampThreeImage: {
        width: 1125,
        height: 432,
      },
      stampFourImage: {
        width: 1125,
        height: 432,
      },
      stampFiveImage: {
        width: 1125,
        height: 432,
      },
      stampSixImage: {
        width: 1125,
        height: 432,
      },
      stampSevenImage: {
        width: 1125,
        height: 432,
      },
      stampEightImage: {
        width: 1125,
        height: 432,
      },
      stampNineImage: {
        width: 1125,
        height: 432,
      },
      stampTenImage: {
        width: 1125,
        height: 432,
      },
      stampElevenImage: {
        width: 1125,
        height: 432,
      },
      stampTwelveImage: {
        width: 1125,
        height: 432,
      },
    },
    apple: {
      logo: {
        width: 480,
        height: 150,
      },
      icon: {
        width: 87,
        height: 87,
      },
      banner: bannerDimensions,
      thumbnail: {
        width: 270,
        height: 270,
      },
    },
    google: {
      icon: {
        width: 660,
        height: 660,
      },
      logo: {
        width: 660,
        height: 660,
      },
      wideLogo: {
        width: 1280,
        height: 400,
      },
      banner: googleBannerDimensions,
    },
    enhancedEventTicket: {
      artwork: {
        width: 1074,
        height: 1344,
      },
      secondaryLogo: {
        width: 405,
        height: 36,
      },
      venueMap: {
        width: 3072,
        height: 3072,
      },
    },
  };
};

export const IMAGE_DIMENSIONS = getImageDimensions('loyalty');
